import React from 'react';
import PropTypes from 'prop-types';

import {ButtonBase, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

import {getParticipantKind, getParticipantResourceRn} from '../communicationUtils';
import MethodSelector from './MethodSelector';
import ParticipantSelector from './ParticipantSelector';

const CommunicationHeader = (props) => {
  const {
    participantDetails,
    participantRns,
    selectedMethod,
    selectedParticipantName,
    selectedParticipantRn,
    selectedParticipantType,
    setSelectedMethod,
    setSelectedParticipantRn,
  } = props;

  const selectedParticipantKind = selectedParticipantRn ? getParticipantKind(selectedParticipantRn) : null;
  const canRouteToParticipant = ['CLIENT', 'CAREGIVER'].includes(selectedParticipantKind);
  const onClickParticipant = () => {
    if (!canRouteToParticipant) return;

    const resourceRn = getParticipantResourceRn(selectedParticipantRn);
    const participantPath = selectedParticipantKind === 'CLIENT' ? `/client/${resourceRn}` : `/caregiver/${resourceRn}`;

    window.open(`${window.location.origin}${participantPath}`, '_blank', 'noopener');
  };

  return (
    <Stack sx={{gap: 1.5}}>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 700,
          color: '#050A14',
        }}
      >
        <Translate expression='case.Communication.Title' />
      </Typography>
      {
        selectedParticipantRn && (
          <ButtonBase
            disabled={!canRouteToParticipant}
            onClick={onClickParticipant}
            sx={{
              'display': 'block',
              'width': '100%',
              'textAlign': 'left',
              'border': '1px solid #ECECF1',
              'borderRadius': '10px',
              'backgroundColor': '#FFFFFF',
              'p': '13px 15px',
              'cursor': canRouteToParticipant ? 'pointer' : 'default',
              '&:hover': {
                backgroundColor: canRouteToParticipant ? '#F7F8FA' : '#FFFFFF',
                borderColor: canRouteToParticipant ? '#DCDDE5' : '#ECECF1',
              },
            }}
            type='button'
          >
            <Stack sx={{gap: 0.75}}>
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: 700,
                  color: '#050A14',
                  wordBreak: 'break-word',
                }}
              >
                {selectedParticipantName}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 400,
                  color: '#63708A',
                }}
              >
                {selectedParticipantType} - {selectedParticipantRn}
              </Typography>
            </Stack>
          </ButtonBase>
        )
      }
      <ParticipantSelector
        participantDetails={participantDetails}
        participantRns={participantRns}
        selectedParticipantRn={selectedParticipantRn}
        setSelectedParticipantRn={setSelectedParticipantRn}
      />
      <MethodSelector
        selectedMethod={selectedMethod}
        setSelectedMethod={setSelectedMethod}
      />
    </Stack>
  );
};

CommunicationHeader.propTypes = {
  participantDetails: PropTypes.object.isRequired,
  participantRns: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedMethod: PropTypes.string.isRequired,
  selectedParticipantName: PropTypes.string.isRequired,
  selectedParticipantRn: PropTypes.string,
  selectedParticipantType: PropTypes.string.isRequired,
  setSelectedMethod: PropTypes.func.isRequired,
  setSelectedParticipantRn: PropTypes.func.isRequired,
};

export default React.memo(CommunicationHeader);
